module.exports = {
  dev: {
    title: 'NN',
    theme: 'alegreya',
    fonts: [{
      family: 'Roboto',
      variants: [ '400', '400italic', '700', '700italic' ],
      subsets: [ 'latin-ext', 'cyrillic-ext' ]
    }]
  },
  azxbet: {
    title: 'SportDemo - ставки на спорт онлайн',
    theme: 'alegreya'
  }
}



// WEBPACK FOOTER //
// ./src/config/apps.js